export default __webpack_public_path__ + "static/media/logo.85eaab0d.webp";